/* ══════════════════════════════════════════════════════════════
   JON Theme — theme.js
   Shopify AJAX Cart API:
     POST /cart/add.js      → add item
     GET  /cart.js          → read cart
     POST /cart/change.js   → update quantity (use id = line item key)
     /checkout              → Shopify checkout
   Product data from window.JON_PRODUCTS (set by home-collection.liquid)
══════════════════════════════════════════════════════════════ */

const JON = (function () {

  /* ── State ── */
  let curHandle    = null;
  let selVariantId = null;
  let carIdx       = 0;
  let carCount     = 1;
  let swipeReady   = false;
  /* Read neutral background from CSS variable set by Shopify settings
     Customizer → Colors → Homepage neutral background */
  const BG_NEUTRAL = () =>
    getComputedStyle(document.documentElement)
      .getPropertyValue('--bg-neutral').trim() || '#FFFFFF';

  /* ── DOM helpers ── */
  const $  = id => document.getElementById(id);
  const bg = ()  => $('bg');
  const nav= ()  => $('nav');
  const home=()  => $('home');

  /* ════════════════════════════════
     INIT
  ════════════════════════════════ */
  function init() {
    initDesktopHover();
    initSoldOut();
    initSwipe();
    refreshCartCount();

    /* If product page (product.liquid rendered #prod with .active), init carousel */
    if ($('prod') && $('prod').classList.contains('active')) {
      initProductPageDirect();
    }
  }

  /* ════════════════════════════════
     DESKTOP: background changes on hover
     Shopify: data-bg from product.metafields.custom.bg_gradient
              data-dark from product.metafields.custom.bg_dark
  ════════════════════════════════ */
  function initDesktopHover() {
    document.querySelectorAll('.fp:not(.sold-out)').forEach(el => {
      const isDark = el.dataset.dark === 'true';
      el.addEventListener('mouseenter', () => {
        if (bg()) bg().style.background = el.dataset.bg;
        if (nav()) nav().classList.toggle('light', isDark);
        if (home()) home().classList.toggle('dark-bg', isDark);
      });
      el.addEventListener('mouseleave', () => {
        if (bg()) bg().style.background = BG_NEUTRAL();
        if (nav()) nav().classList.remove('light');
        if (home()) home().classList.remove('dark-bg');
      });
    });
  }

  /* ════════════════════════════════
     SOLD OUT: dim mobile slides
  ════════════════════════════════ */
  function initSoldOut() {
    document.querySelectorAll('.slide.sold-out .slide-item img, .slide.sold-out .slide-item svg').forEach(el => {
      el.style.opacity = '.45';
    });
  }

  /* ════════════════════════════════
     OPEN PRODUCT PANEL (homepage SPA)
     Shopify: product data from window.JON_PRODUCTS
  ════════════════════════════════ */
  function openProd(handle) {
    const products = window.JON_PRODUCTS || {};
    const p = products[handle];
    if (!p || p.soldOut) return;

    curHandle    = handle;
    selVariantId = null;
    carIdx       = 0;

    const mob = window.innerWidth < 769;

    /* Background */
    const prodBg = $('prod-bg');
    if (prodBg) prodBg.style.background = p.bgProd;

    /* Title — Shopify: {{ product.title }} */
    const titleEl = $('pp-title');
    if (titleEl) titleEl.textContent = p.title;

    /* Description — Shopify: {{ product.description }} */
    const descEl = $('pp-desc');
    if (descEl) descEl.textContent = p.desc;

    /* Price */
    const priceEl = $('ab-price');
    if (priceEl) priceEl.textContent = p.price;
    const txtEl = $('ab-txt');
    if (txtEl) txtEl.textContent = 'Add to bag';

    const colorField = $('pp-color-field');
    const colorDiv   = $('pp-color-div');
    const colorLbl   = $('pp-color-lbl');
    const colorChip  = $('pp-color-chip');
    const colorName  = $('pp-color-name');
    const hasColor   = !!(p.clrName || p.gColor);
    if (colorField) colorField.style.display = hasColor ? 'block' : 'none';
    if (colorDiv) colorDiv.style.display = hasColor ? 'block' : 'none';
    if (hasColor) {
      if (colorLbl) colorLbl.textContent = '[ ' + String(p.clrName || 'COLOR').toUpperCase() + ' ]';
      if (colorChip) colorChip.style.background = p.gColor || '#888888';
      if (colorName) colorName.textContent = p.clrName || '';
    }

    /* Size label reset */
    const szLbl = $('pp-sz-lbl');
    if (szLbl) { szLbl.textContent = '[ — ]'; szLbl.style.color = 'rgba(255,255,255,.7)'; }

    /* Build carousel from product images — Shopify: {{ product.images }} */
    buildCarousel(p, mob);

    /* Build size buttons — Shopify: {{ product.variants }} */
    buildSizes(p.variants);

    /* Transition home → product */
    if (bg())  bg().style.background = BG_NEUTRAL();
    if (nav()) nav().classList.remove('light');
    if (home()) home().classList.add('out');
    document.body.classList.add('product-open');

    setTimeout(() => {
      if (home()) home().style.zIndex = '5';
      const prod = $('prod');
      if (prod) { prod.classList.add('active'); prod.scrollTop = 0; }
      const addBar = $('add-bar');
      if (addBar) addBar.classList.add('show');
      const footer = $('site-footer');
      if (footer) footer.style.display = 'none';
    }, 300);
  }

  /* ════════════════════════════════
     CAROUSEL
  ════════════════════════════════ */
  function buildCarousel(p, mob) {
    const slidesEl = $('p-slides');
    const dotsEl   = $('p-dots');
    if (!slidesEl || !dotsEl) return;

    const images = (p.images || []).filter(Boolean);
    /* No limit — all product images shown, including size table if uploaded to Shopify */
    carCount = Math.max(1, images.length);

    if (images.length > 0) {
      /* Shopify: each src from {{ image | img_url: 'master' }}
         Last image can be the size table — upload it last in Admin → Products → Media */
      slidesEl.innerHTML = images.map((src, i) => `
        <div class="p-slide">
          <img class="p-img-item"
               src="${src}"
               alt="${escHtml(p.title)}"
               loading="${i === 0 ? 'eager' : 'lazy'}">
        </div>`).join('');
    } else {
      carCount = 1;
      slidesEl.innerHTML = `
        <div class="p-slide">
          <div style="width:220px;height:260px;background:rgba(255,255,255,.12);border-radius:4px"></div>
        </div>`;
    }
    slidesEl.style.transform = 'translateX(0)';

    /* Dots — one per image, data-count for CSS to adapt size */
    dotsEl.innerHTML = '';
    dotsEl.dataset.count = carCount;
    for (let i = 0; i < carCount; i++) {
      const d = document.createElement('div');
      d.className = 'p-dot' + (i === 0 ? ' on' : '');
      d.onclick = () => goSlide(i);
      dotsEl.appendChild(d);
    }
  }

  function goSlide(i) {
    carIdx = i;
    const slides = $('p-slides');
    if (slides) slides.style.transform = `translateX(-${i * 100}%)`;
    document.querySelectorAll('.p-dot').forEach((d, j) => d.classList.toggle('on', j === i));
  }

  /* ════════════════════════════════
     SIZE BUTTONS
     Shopify: variant.id, variant.title, variant.available
  ════════════════════════════════ */
  function buildSizes(variants) {
    const szEl = $('pp-sizes');
    if (!szEl) return;
    szEl.innerHTML = '';
    (variants || []).forEach(v => {
      const b = document.createElement('button');
      b.type = 'button';
      b.className = 'sz' + (v.available ? '' : ' na');
      b.textContent = cleanVariantTitle(v.title);
      if (v.available) {
        b.addEventListener('click', () => pickSz(cleanVariantTitle(v.title), v.id, v.price, b));
      }
      szEl.appendChild(b);
    });
  }

  /* ── Pick size on homepage SPA ── */
  function pickSz(title, variantId, price, btn) {
    selVariantId = variantId;
    const szLbl = $('pp-sz-lbl');
    if (szLbl) { szLbl.textContent = '[ ' + title + ' ]'; szLbl.style.color = '#fff'; }
    document.querySelectorAll('.sz').forEach(b => b.classList.remove('on'));
    if (btn) btn.classList.add('on');
  }

  /* ── Pick size on direct product page (product.liquid) ── */
  function pickSzDirect(title, variantId, price, btn) {
    title = cleanVariantTitle(title);
    selVariantId = variantId;
    const szLbl = $('pp-sz-lbl');
    if (szLbl) { szLbl.textContent = '[ ' + title + ' ]'; szLbl.style.color = '#fff'; }
    const priceEl = $('ab-price');
    if (priceEl) priceEl.textContent = price;
    document.querySelectorAll('.sz').forEach(b => b.classList.remove('on'));
    if (btn) btn.classList.add('on');
  }

  /* ── Init product page when arriving via direct URL ── */
  function initProductPageDirect() {
    document.body.classList.add('product-open');
    carCount = Math.max(1, document.querySelectorAll('#p-slides .p-slide').length);
    /* Hide footer — it would overlap the sticky add-bar on product pages */
    const footer = $('site-footer');
    if (footer) footer.style.display = 'none';
    /* Select first available variant on direct product pages for a stable initial state */
    const firstAvailable = document.querySelector('#pp-sizes .sz:not(.na)');
    if (firstAvailable && !document.querySelector('#pp-sizes .sz.on')) {
      firstAvailable.click();
    }
    /* swipeReady guard ensures initSwipe() already ran in init() — no duplicate needed */
  }

  /* ════════════════════════════════
     SIZE GUIDE MODAL
     Shopify: content from product.metafields.custom.size_guide
     Create in Admin → Settings → Custom data → Products:
       Key: size_guide | Namespace: custom | Type: multi_line_text
     Fill per product in Admin → Products → [product] → Metafields
  ════════════════════════════════ */
  function openSizeGuide() {
    const modal = $('sg-modal');
    if (!modal) return;

    /* Get current product's size guide content */
    const products = window.JON_PRODUCTS || {};
    const p = curHandle ? products[curHandle] : (window.JON_CURRENT_PRODUCT || null);
    const content = p ? (p.sizeGuide || '') : '';

    /* Title */
    const titleEl = $('sg-title');
    if (titleEl && p) titleEl.textContent = p.title.toUpperCase() + ' (SIZE GUIDE)';

    /* Body */
    const bodyEl = $('sg-body');
    if (bodyEl) {
      if (content) {
        bodyEl.innerHTML = content;
      } else {
        bodyEl.innerHTML = '<p class="sg-empty">No size guide available.<br>Add one in Admin → Products → Metafields → size_guide.</p>';
      }
    }

    modal.classList.add('active');
  }

  function closeSizeGuide() {
    const modal = $('sg-modal');
    if (modal) modal.classList.remove('active');
  }


  function goHome() {
    /* UX Fix 1: on a direct product URL (/products/...) there is no #home div.
       Redirect to homepage instead of doing nothing. */
    if (!home()) {
      window.location.href = '/';
      return;
    }
    closeCart();
    const prod   = $('prod');
    const addBar = $('add-bar');
    const footer = $('site-footer');
    const homeEl = home();

    if (prod)   prod.classList.remove('active');
    if (addBar) addBar.classList.remove('show');
    if (footer) footer.style.display = 'flex';

    if (homeEl) {
      homeEl.style.zIndex = '10';
      setTimeout(() => homeEl.classList.remove('out'), 50);
    }

    if (bg())  bg().style.background = BG_NEUTRAL();
    if (nav()) nav().classList.remove('light');
    if (homeEl) homeEl.classList.remove('dark-bg');

    selVariantId = null;
    curHandle    = null;
    document.body.classList.remove('product-open');
  }

  function goBack() {
    const prod = $('prod');
    if (home() && prod && prod.classList.contains('active')) {
      goHome();
      return;
    }
    if (window.history.length > 1) {
      window.history.back();
    } else {
      window.location.href = '/';
    }
  }

  /* ════════════════════════════════
     ADD TO CART
     Shopify: POST /cart/add.js
     Body: { id: variantId, quantity: 1 }
  ════════════════════════════════ */
  function addToCart() {
    if (!selVariantId) {
      const szLbl = $('pp-sz-lbl');
      if (szLbl) {
        szLbl.textContent = '[ SELECT SIZE ]';
        szLbl.style.color = '#e05c5c';
        /* Auto-reset after 2.5s if user still hasn't picked */
        setTimeout(() => {
          if (!selVariantId && szLbl) {
            szLbl.textContent = '[ — ]';
            szLbl.style.color = 'rgba(255,255,255,.7)';
          }
        }, 2500);
      }
      return;
    }

    const addBarEl = $('add-bar');
    const txtEl    = $('ab-txt');

    /* UX Fix 2: disable button immediately to prevent double-tap double-add */
    if (addBarEl) addBarEl.disabled = true;
    if (txtEl)    txtEl.textContent = 'ADDING...';

    fetch('/cart/add.js', {
      method:  'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body:    JSON.stringify({ id: selVariantId, quantity: 1 })
    })
    .then(r => {
      if (!r.ok) throw new Error('Cart error ' + r.status);
      return r.json();
    })
    /* UX Fix 3: refreshCart() already fetches /cart.js and renders the cart.
       Pass the cart data directly into openCartWithData() — no second fetch needed. */
    .then(() => refreshCart())
    .then(cart => {
      openCartWithData(cart);
      if (txtEl)    txtEl.textContent = 'Add to bag';
      if (addBarEl) addBarEl.disabled = false;
    })
    .catch(err => {
      console.error('[JON] Add to cart error:', err);
      if (txtEl)    txtEl.textContent = 'Error — try again';
      if (addBarEl) addBarEl.disabled = false;
      setTimeout(() => { if (txtEl) txtEl.textContent = 'Add to bag'; }, 2500);
    });
  }

  /* Same function used from product.liquid direct URL */
  function addToCartDirect() { addToCart(); }

  /* ════════════════════════════════
     CART — Shopify AJAX
  ════════════════════════════════ */

  /* GET /cart.js → render cart */
  function refreshCart() {
    return fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
      .then(r => r.json())
      .then(cart => { renderCart(cart); return cart; });
  }

  /* Just update the count badge */
  function refreshCartCount() {
    fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
      .then(r => r.json())
      .then(cart => {
        const cnt = $('n-cnt');
        if (cnt) cnt.textContent = cart.item_count;
      })
      .catch(() => {});
  }

  /* Render cart items from Shopify cart object */
  function renderCart(cart) {
    const cnt    = $('n-cnt');
    const empty  = $('c-empty-msg');
    const items  = $('c-items');
    const foot   = $('c-foot');

    if (cnt) cnt.textContent = cart.item_count;

    if (!cart.item_count) {
      if (empty) empty.style.display = 'block';
      if (items) items.innerHTML = '';
      if (foot)  foot.style.display = 'none';
      return;
    }

    if (empty) empty.style.display = 'none';
    if (foot)  foot.style.display = 'block';

    if (items) {
      items.innerHTML = cart.items.map(item => {
        /* Shopify: item.image is the product image URL from Shopify CDN */
        const thumb = item.image
          ? `<img src="${item.image}" alt="${escHtml(item.product_title)}">`
          : '';
        const keyAttr = escHtml(item.key);
        const variantParts = String(item.variant_title || '').split('/').map(p => p.trim()).filter(Boolean);
        const colour = variantParts.length > 1 ? variantParts[0] : (variantParts[0] || '');
        const size = variantParts.length > 1 ? variantParts[variantParts.length - 1] : (variantParts[0] || '');
        const colourLine = colour ? `${escHtml(colour)} <span class="cart-dot"></span>` : '';
        const sizeLine = size ? `SIZE: ${escHtml(size)}` : '';
        return `
          <div class="ci">
            <div class="ci-thumb">${thumb}</div>
            <div>
              <div class="ci-name">${escHtml(item.product_title)}</div>
              <div class="ci-clr"><span class="ci-cname">${colourLine}</span></div>
              <div class="ci-qty">
                <span>QTY&nbsp;</span>
                <button type="button" class="ci-qty-btn" data-key="${keyAttr}" data-qty="${item.quantity - 1}" onclick="JON.changeQtyFromEl(this)" aria-label="Decrease">-</button>
                <span class="ci-qty-n">${item.quantity}</span>
                <button type="button" class="ci-qty-btn" data-key="${keyAttr}" data-qty="${item.quantity + 1}" onclick="JON.changeQtyFromEl(this)" aria-label="Increase">+</button>
                <button type="button" class="ci-del" data-key="${keyAttr}" onclick="JON.removeFromEl(this)">DELETE</button>
              </div>
            </div>
            <div class="ci-price">${formatMoney(item.line_price)}<br><span class="ci-cname">${sizeLine}</span></div>
          </div>`;
      }).join('');
    }

    const totalEl = $('c-total');
    if (totalEl) totalEl.textContent = formatMoney(cart.total_price);
  }

  /* POST /cart/change.js — update quantity via data attribute (safe key passing) */
  function changeQtyFromEl(btn) {
    const key = btn.dataset.key;
    const qty = parseInt(btn.dataset.qty, 10);
    changeQty(key, qty);
  }

  /* POST /cart/change.js — remove item via data attribute */
  function removeFromEl(btn) {
    changeQty(btn.dataset.key, 0);
  }

  /* Shopify: POST /cart/change.js with { id: lineItemKey, quantity: qty } */
  function changeQty(key, qty) {
    fetch('/cart/change.js', {
      method:  'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body:    JSON.stringify({ id: key, quantity: qty })
    })
    .then(r => r.json())
    .then(cart => renderCart(cart))
    .catch(err => console.error('[JON] Cart change error:', err));
  }

  /* Format money: Shopify returns cents (integer) → USD store */
  function formatMoney(cents) {
    return '$' + (cents / 100).toFixed(2);
  }

  /* Open cart: fetch fresh data first (used when opening manually) */
  function openCart() {
    refreshCart().then(() => {
      const ov = $('cart-ov');
      if (ov) ov.classList.add('active');
    });
  }

  /* Open cart with already-fetched data (used after addToCart — no second fetch) */
  function openCartWithData(cart) {
    renderCart(cart);
    const ov = $('cart-ov');
    if (ov) ov.classList.add('active');
  }

  function closeCart() {
    const ov = $('cart-ov');
    if (ov) ov.classList.remove('active');
  }

  /* ════════════════════════════════
     SWIPE — carousel touch events
  ════════════════════════════════ */
  function initSwipe() {
    if (swipeReady) return;   /* guard: never attach twice */
    swipeReady = true;
    const car = $('p-carousel');
    if (!car) return;
    let sx = 0;
    car.addEventListener('touchstart', e => { sx = e.touches[0].clientX; }, { passive: true });
    car.addEventListener('touchend', e => {
      const dx = e.changedTouches[0].clientX - sx;
      if (Math.abs(dx) > 40) {
        /* carCount updated by buildCarousel — works for any number of images */
        dx < 0
          ? goSlide(Math.min(carIdx + 1, carCount - 1))
          : goSlide(Math.max(carIdx - 1, 0));
      }
    }, { passive: true });
  }

  function cleanVariantTitle(title) {
    const parts = String(title || '').split('/').map(p => p.trim()).filter(Boolean);
    return parts.length ? parts[parts.length - 1] : String(title || '');
  }

  /* ── Utility: escape HTML to prevent XSS in innerHTML ── */
  function escHtml(str) {
    if (!str) return '';
    return String(str)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#39;');
  }

  /* ════════════════════════════════
     PUBLIC API
  ════════════════════════════════ */
  return {
    init,
    openProd,
    goHome,
    goBack,
    goSlide,
    pickSz,
    pickSzDirect,
    addToCart,
    addToCartDirect,
    changeQtyFromEl,
    removeFromEl,
    openCart,
    closeCart,
    openSizeGuide,
    closeSizeGuide
  };

})();

/* Init on DOM ready */
document.addEventListener('DOMContentLoaded', () => JON.init());
